import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import { WelcomeBoardLayout } from '../../../common/interfaces';

interface LayoutSettingsTabProps {
    mainLayoutId: string;
    emptyLayoutId: string;
    layouts: WelcomeBoardLayout[];
    loadingLayouts: boolean;
    onMainLayoutChange: (value: string) => void;
    onEmptyLayoutChange: (value: string) => void;
}

export const LayoutSettingsTab: React.FC<LayoutSettingsTabProps> = ({
    mainLayoutId,
    emptyLayoutId,
    layouts,
    loadingLayouts,
    onMainLayoutChange,
    onEmptyLayoutChange
}) => {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Layout Configuration
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    Select layouts to use for different welcome board states
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <InputLabel>Main Layout</InputLabel>
                            <Select
                                value={mainLayoutId}
                                label="Main Layout"
                                onChange={(e) => onMainLayoutChange(e.target.value as string)}
                                disabled={loadingLayouts}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {layouts.map((layout) => (
                                    <MenuItem key={layout.id} value={layout.id || ''}>
                                        {layout.name || `Layout ${layout.id}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <InputLabel>Empty Layout</InputLabel>
                            <Select
                                value={emptyLayoutId}
                                label="Empty Layout"
                                onChange={(e) => onEmptyLayoutChange(e.target.value as string)}
                                disabled={loadingLayouts}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {layouts.map((layout) => (
                                    <MenuItem key={layout.id} value={layout.id || ''}>
                                        {layout.name || `Layout ${layout.id}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
